import { gql } from '@apollo/client'
import { AziendaTemplate } from 'components/template'
import { initializeApollo } from 'utils/apollo'
import { normalizeGraphQLResults } from 'utils/safe'
import { NextWrapper } from '../../data-fetching-wrapper'

function Azienda({ pagina, aziendaData }) {
  return <AziendaTemplate pagina={pagina} aziendaData={aziendaData} />
}

export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()

  const {
    data: { pagina, boxHero, boxMarketing2Many, boxAzienda, boxStoria },
  } = await client.query({
    query: gql`
      query {
        pagina(chiave: "azienda") {
          titolo
          breadcrumbs {
            titolo
            url
          }
          seo {
            title
            description
            image
          }
          chiave
        }
        boxHero(chiave: "azienda") {
          titolo
          testo
          image
        }
        boxMarketing2Many(chiave_Istartswith: "azienda") {
          edges {
            node {
              titolo
              testo
              imageThumb
              imageVerticalPosition
              imageHorizontalPosition
              contentStyle
              backgroundStyle
              finalUrl
              cta
            }
          }
        }
        boxAzienda: boxSlider(chiave: "azienda") {
          stile
          slides {
            titolo
            sottotitolo
            testo
          }
        }
        boxStoria: boxSlider(chiave: "storia") {
          stile
          slides {
            titolo
            sottotitolo
            testo
          }
        }
      }
    `,
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  const aziendaData = {
    hero: normalizeGraphQLResults(boxHero),
    boxMarketing2: normalizeGraphQLResults(boxMarketing2Many),
    boxAzienda: normalizeGraphQLResults(boxAzienda),
    boxStoria: normalizeGraphQLResults(boxStoria),
  }

  return {
    props: { pagina, aziendaData },
    revalidate: 60 * 5,
  }
})

export default Azienda
